<template>
    <van-tabbar v-model="active">
        <van-tabbar-item :to="'/'+$route.params.mid" icon="apps-o">MENU</van-tabbar-item>
        <van-tabbar-item :to="'/'+$route.params.mid+'/profile/orders'" icon="orders-o">ORDINI</van-tabbar-item>
        <van-tabbar-item :to="'/'+$route.params.mid+'/profile/dashboard'" icon="user-o">PROFILO</van-tabbar-item>
    </van-tabbar>
</template>
<script>
  export default {
    name: 'TabBar',

    data: () => ({
      active: 0
    }),
  }
</script>